import {
  sessionNumberFormatter,
  dateOrDateTimeFormatter, dateTimeFormatter, clientIdFormatter, paymentAmountFormatter, paymentMethodFormatter,
} from '../../utils/formatters';

export const getPaymentSessionId = (value, row = {}) => {
  const source = row || {};
  const session = value || source.session;

  if (session && typeof session === 'object') {
    return session.id || session.session_id || source.session_id || '';
  }

  return session || source.session_id || '';
};

const paymentSessionFormatter = (value, row) => {
  const sessionId = getPaymentSessionId(value, row);

  return sessionId ? sessionNumberFormatter(sessionId) : '';
};

export const MODULE_NAME = 'PAYMENT_LOG_PAGE';
export const paymentLogColumns = [
  // {
  //   dataField: 'checkBox',
  //   disableSort: true,
  //   text: 'Выбор строки',
  //   hidden: true,
  //   headerClassName: 'text-center column-relative',
  //   dataClassName: 'align-middle column-relative',
  // },
  {
    dataField: 'host',
    text: 'Хост оплаты',
    formatter: e => e && e.name,
    toCopyFormatter: e => e && e.name,
    disableSort: true,
    hidden: false,
    dataClassName: 'align-middle',
    headerClassName: 'host-name-column',
  },
  {
    dataField: 'paid_at',
    text: 'Дата, время оплаты',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: a => dateOrDateTimeFormatter(a),
    toCopyFormatter: dateTimeFormatter,
    headerClassName: 'date-time-column',
    hidden: true,
  },
  {
    dataField: 'amount',
    text: 'Сумма оплаты, руб',
    disableSort: true,
    dataClassName: 'align-middle',
    headerClassName: 'amount-column',
    formatter: paymentAmountFormatter,
    toCopyFormatter: paymentAmountFormatter,
    hidden: true,
  },
  {
    dataField: 'method_label',
    text: 'Способ оплаты',
    disableSort: true,
    dataClassName: 'align-middle',
    hidden: true,
    headerClassName: 'method-column',
    formatter: paymentMethodFormatter,
    toCopyFormatter: paymentMethodFormatter,
  },
  {
    dataField: 'type_label',
    text: 'Тип платежа',
    disableSort: true,
    dataClassName: 'align-middle',
    headerClassName: 'type-column',
    hidden: true,
  },
  {
    dataField: 'masked_pan',
    text: 'Номер карты',
    disableSort: true,
    dataClassName: 'align-middle',
    hidden: true,
    headerClassName: 'masked-column',
  },
  {
    dataField: 'rrn',
    text: 'RRN',
    disableSort: true,
    dataClassName: 'align-middle',
    hidden: true,
    headerClassName: 'rrn-column',
  },
  {
    dataField: 'auth_code',
    text: 'Код авторизации',
    disableSort: true,
    dataClassName: 'align-middle',
    hidden: true,
    headerClassName: 'auth-code-column',
  },
  {
    dataField: 'uip',
    text: 'УИП',
    disableSort: true,
    dataClassName: 'align-middle',
    hidden: true,
    headerClassName: 'uip-column',
  },
];

export const addPaymentLogColumns = [
  {
    dataField: 'session',
    text: 'Номер сессии',
    disableSort: true,
    dataClassName: 'align-middle',
    hidden: true,
    headerClassName: 'session-number-column',
    formatter: paymentSessionFormatter,
    toCopyFormatter: getPaymentSessionId,
  },
];
